import { SendingTypes } from '@sigmasms/shared-types'

import { catchSymbolsMenus, components, labelModes, services } from '@/utils'

import rulesActionsDialogGeneratorsButtons from '@/components/rules/actions/generators/buttons'
import { baseClass } from '@/components/rules/utils'
import selectorSendingType from '@/components/selector/sendingType'
import catchSymbolsInput from '@/components/services/sendings/catchSymbolsInput'
import fallbackOptions from '@/components/services/sendingsCreate/form/fallback/options'

function renderBasicFields(h) {
  return h(
    'div',
    {
      class: `${baseClass}-card__row`
    },
    [
      h(
        selectorSendingType,
        {
          props: {
            value: this.proxy.type,
            label: this.getTranslate(`${baseClass}.labels.type`),
            permission: `advanced.${services.sendings}.create`,
            readonly: this.readonly
          },
          on: {
            input: event => {
              this.proxy.type = event
            }
          }
        }
      ),

      h(
        components.select,
        {
          props: {
            value: this.proxy.payload.sender,
            label: this.getTranslate(`${baseClass}.labels.sender`),
            service: services.sendernames,
            query: { type: this.proxy.type },
            itemTitle: 'name',
            itemValue: 'name',
            details: false,
            dense: true,
            clearable: true,
            combobox: true,
            autocomplete: true,
            readonly: this.readonly
          },
          on: {
            input: event => {
              this.proxy.payload.sender = event
            }
          }
        }
      )
    ]
  )
}

function renderTextField(h) {
  return h(
    components.textarea,
    {
      props: {
        value: this.proxy.payload.text,
        label: this.getTranslate(`${baseClass}.labels.text`),
        labelMode: labelModes.hidden,
        details: false,
        dense: true,
        clearable: true,
        readonly: this.readonly
      },
      on: {
        input: event => {
          this.proxy.payload.text = event
        }
      }
    }
  )
}

function renderViberButtons(h) {
  if (this.proxy.payload.button) {
    return h(
      components.card,
      {
        class: `${baseClass}-card`,
        props: {
          dashed: true,
          outline: true,
          rounded: true
        }
      },
      [
        h(
          catchSymbolsInput,
          {
            props: {
              value: this.proxy.payload.button.url,
              label: this.getTranslate(`${services.sendings}.labels.button.url`),
              hint: this.getTranslate(`${services.sendings}.hints.button.url`),
              type: 'url',
              dense: true,

              rounded: true,
              tags: this.tags,
              customMenu: catchSymbolsMenus.custom.$
            },
            on: {
              input: event => {
                this.proxy.payload.button.url = event
              }
            }
          }
        ),

        h(
          catchSymbolsInput,
          {
            props: {
              value: this.proxy.payload.button.text,
              label: this.getTranslate(`${services.sendings}.labels.button.text`),
              hint: this.getTranslate(`${services.sendings}.hints.button.text`),

              dense: true,
              rounded: true,
              tags: this.tags,
              customMenu: catchSymbolsMenus.custom.$
            },
            on: {
              input: event => {
                this.proxy.payload.button.text = event
              }
            }
          }
        )
      ]
    )
  }
}
function renderWhatsAppButtons(h) {
  if (this.proxy.payload.buttons) {
    return h(
      rulesActionsDialogGeneratorsButtons,
      {
        props: {
          value: this.proxy.payload.buttons
        },
        on: {
          input: event => {
            this.proxy.payload.buttons = event
          }
        }
      }
    )
  }
}
function renderButtons(h) {
  switch (this.proxy.type) {
    case SendingTypes.viber: return renderViberButtons.call(this, h)
    case SendingTypes.vk:
    case SendingTypes.whatsapp: return renderWhatsAppButtons.call(this, h)
  }
}

function renderFallbackOptions(h) {
  return h(
    fallbackOptions,
    {
      props: {
        value: this.proxy.$options,
        readonly: this.readonly
      },
      on: {
        input: event => {
          this.proxy.$options = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    components.card,
    {
      class: `${baseClass}-card`,
      props: {
        dashed: true,
        outline: true,
        rounded: true
      }
    },
    [
      renderBasicFields.call(this, h),
      renderTextField.call(this, h),
      renderButtons.call(this, h),
      renderFallbackOptions.call(this, h)
    ]
  )
}
